<template>
  <div class="container">
    <div class="d-flex justify-content-center w-100 mt-5 mb-5">
      <div id="paypal-button-container" class="w-50"></div>
      <p id="result-message"></p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import axios, { all } from "axios";

export default {
  setup() {
    const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
    const resultMessage = ref("");
    const router = useRouter();

    const loadPaypalScript = () => {
      return new Promise((resolve, reject) => {
        if (document.querySelector("script[src='https://www.paypal.com/sdk/js']")) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src =
          "https://www.paypal.com/sdk/js?client-id=AeRqU4P4V1hIGBxWSPM2SBK53s48sv37BBed40r1R-HIwHzfErKaNQlyTa61Ngm0vmJo10SI3HJ_PsjF&currency=USD";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    const initPaypalButtons = () => {
      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            layout: "vertical",
            color: "gold",
            label: "paypal",
          },

          async createOrder() {
            return router.currentRoute.value.query.id;
          },

          async onApprove(data, actions) {
            axios({
              method: "POST",
              url:
                apiBaseUrl +
                "paypal-service/capture-order?id_order_paypal=" +
                router.currentRoute.value.query.id,
            })
              .then((response) => {
                if (response.data.data.status == "COMPLETED") {
                  window.location.href = "/payment/success";
                }
              })
              .catch((error) => {
                window.location.href = "/payment/failed";
              });
          },
        })
        .render("#paypal-button-container");
    };

    onMounted(async () => {
      try {
        await loadPaypalScript();
        initPaypalButtons();
      } catch (error) {
        console.error("Failed to load PayPal script:", error);
        resultMessage.value = "Failed to load PayPal. Please try again later.";
      }
    });

    return {
      resultMessage,
    };
  },
};
</script>
